import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiClient } from '@/lib/apiClient'
import { API_ROUTES } from '@/constants/apiRoutes'
import { AffiliationList, AffiliationState } from '@/types/index'

export const getAffiliations = createAsyncThunk<AffiliationState>(API_ROUTES.ADMIN_AFFILIATION_ENDPOINT, async () => {
  const res = await apiClient.get<AffiliationState>(API_ROUTES.ADMIN_AFFILIATION_ENDPOINT)
  return res
})

const initialState: AffiliationList = {
  affiliations: [],
  loading: false,
  error: null,
}

const adminAffiliationSlice = createSlice({
  name: 'adminAffiliation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET AFFILIATIONS
      .addCase(getAffiliations.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getAffiliations.fulfilled, (state, action) => {
        state.affiliations = action.payload.items
        state.loading = false
      })
      .addCase(getAffiliations.rejected, (state, action) => {
        state.error = action.error.message || 'Error'
        state.loading = false
      })
  },
})

export default adminAffiliationSlice.reducer
